import React from "react";
import "./ServiceArea.css";

const ServiceAreas = () => {
  const cities = [
    "Aurora", "Bolton", "Bradford", "Burlington", "Caledon",
    "Etobicoke", "Georgetown", "Innisfil", "King City", "Kleinburg",
    "Markham", "Milton", "Mississauga", "Newmarket", "North York",
    "Oakville", "Richmond Hill", "Scarborough", "Stouffville",
    "Toronto", "Unionville", "Vaughan", "Woodbridge"
  ];

  return (
    <section className="service-areas text-center py-5">
    <div className="container">
      <h2 className="fw-bold mb-3 text-center" data-sal='slide-left' data-sal-duration="1000" data-sal-delay="300" >Our Service Areas</h2>
      <p className="mb-4" data-sal='slide-right' data-sal-duration="1000" data-sal-delay="300">
        Serving the Greater Toronto Horseshoe Area for all your <br className="d-none d-md-block" />
        kitchen, basement, and bathroom renovation needs.
      </p>
  
   <div className="area-list d-flex flex-wrap justify-content-center gap-2">
  {cities.map((city, index) => (
    <span
      key={index}
      className="text-dark px-3 py-2"
      data-sal="slide-down"
      data-sal-delay={index * 100} 
      data-sal-duration="3000"
      data-sal-easing="ease"
   
    >
      {city}
    </span>
  ))}
</div>

    </div>
  </section>
  
  );
};

export default ServiceAreas;
